import { IApplicationContext } from '../../../shared/types/applicationContext';
import { IApplicationState } from '../../../shared/types/redux';
import { createReduxStore } from '../../../shared/utils/redux';

export function createApplicationState(context: IApplicationContext) {
  const { config } = context;

  const initialState = config.getStrict<IApplicationState>('initialState');
  const isRenterFormEnabled = context.config.get<boolean>('all-recommendations.renterForm.enabled') || false;

  return createReduxStore(context, { ...initialState, isRenterFormEnabled }, true);
}
